import type { AccessStatusResponse } from '@lunya/contracts'

import type { AccessStatus } from '../../types'

/** DTO → клиентский тип. Поля перечислены явно, `...spread` запрещён (docs/data-layer.md §7). */
export const mapAccessStatusFromApi = (dto: AccessStatusResponse): AccessStatus => ({
  isAllowed: dto.allowed,
  reason: dto.reason,
  channelUrl: dto.channel_url ?? undefined,
  graceEndsAt: dto.grace_ends_at ? new Date(dto.grace_ends_at) : undefined,
})
